import { LitEntity, SirenActionMixin, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-surface';
import '../../common/bn-flash';

class FindDevice extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this.deviceId = '';
  }

  static get properties() {
    return {
      deviceId: { type: String },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .group + .group {
        margin-top: 1rem;
      }
      .button {
        margin-top: 1rem;
      }
      h3 {
        margin: 0;
      }
    `];
  }

  render() {
    return html`
      <form @submit="${this._findDevice}">
        <bn-flash id="status"></bn-flash>
        <div class="group">
          <label>Device ID</label>
          <input type="text" value="${this.deviceId}" @change="${(e) => this.deviceId = e.target.value}">
        </div>
        <div class="form-buttons">
          <button class="button button--contained" @click="${this._findDevice}" type="submit">Find Device</button>
        </div>
      </form>
    `;
  }

  firstUpdated() {
    const input = this.renderRoot.querySelector('input');
    if (input) {
      input.focus();
    }
  }

  _error(msg) {
    const status = this.shadowRoot.querySelector('#status');
    status.clear();
    status.critical(msg);
  }

  async _findDevice(e) {
    e.preventDefault();
    const status = this.shadowRoot.querySelector('#status');
    status.clear();

    const action = this.entity.getActionByName('find-device');
    if (!action) {
      this._error('Could not find [find-device] action');
      return;
    }

    const fields = this.getActionFields(action);
    fields.set('deviceId', this.deviceId);

    try {
      const { entity, error } = await this.submitAction(action, fields);
      if (error) {
        this._error(error);
      } else {
        status.success('Device found. Redirecting.');
        this.dispatchEvent(new CustomEvent('success', { detail: { entity } }));
      }
    } catch (err) {
      this._error('Could not find device.');
    }
  }
}

window.customElements.define('find-device', FindDevice);
